import api from "../api";

class PropertyViewingsService {
  // Get property viewings calendar
  getPropertyViewingsCalendar(propertyId) {
    return api.get(`/propertyviewings/property/${propertyId}`);
  }

  // Get property viewings for a specific property
  getPropertyViewings(propertyId, statusId = null) {
    return api.get(`/property_viewings/property/${propertyId}/viewings`, {
      params: { status_id: statusId },
    });
  }

  // Get property viewings statistics
  getPropertyViewingsStatistics(propertyId) {
    return api.get(`/propertyviewings/property/${propertyId}/statistics`);
  }

  // Create property viewing
  createPropertyViewing(data) {
    return api.post("/propertyviewings", data);
  }

  // Update property viewing
  updatePropertyViewing(id, data) {
    return api.put(`/propertyviewings/${id}`, data);
  }

  // Delete property viewing
  deletePropertyViewing(id) {
    return api.delete(`/propertyviewings/${id}`);
  }

  // Get property viewing details
  getPropertyViewingDetails(id) {
    return api.get(`/propertyviewings/${id}/view-details`);
  }

  // Get viewing details (alias for getPropertyViewingDetails)
  getViewingDetails(id) {
    return api.get(`/property_viewings/${id}/view-details`);
  }

  // Get user's property viewings for SALES WITH GUARDIANS dashboard
  // Load all viewings (like Laravel) for client-side DataTable pagination
  // FIXED: Use /user/:userId endpoint (not /user/:userId/viewings) to get ALL viewings without pagination
  getUserViewings(userId, limit = 10000) {
    // Use the endpoint that returns ALL viewings without pagination (matches Laravel)
    return api.get(`/propertyviewings/user/${userId}`);
  }

  // Edit property viewing
  editPropertyViewing(id) {
    return api.get(`/propertyviewings/${id}/edit`);
  }

  // Attend property viewing
  attendPropertyViewing(id) {
    return api.get(`/propertyviewings/${id}/attend`);
  }

  // Attend viewing (alias for attendPropertyViewing)
  attendViewing(id) {
    return api.post(`/property_viewings/${id}/attend`);
  }

  // Copy property viewing
  copyPropertyViewing(id, period) {
    return api.get(`/property_viewings/copy/${id}/${period}`);
  }

  // Copy viewing (alias for copyPropertyViewing)
  copyViewing(id, period) {
    return api.post(`/property_viewings/copy/${id}/${period}`);
  }

  // Change property viewing status
  changePropertyViewingStatus(id, statusId) {
    return api.post(`/property_viewings/${id}/change-status/${statusId}`);
  }

  // Change property viewing confirmation status (Laravel route)
  changePropertyViewingConfirmationStatus(confirmationId, statusId) {
    return api.post(
      `/propertyviewingsconfirmations/change-status/${confirmationId}/${statusId}`
    );
  }

  // Delete property viewing confirmation
  deletePropertyViewingConfirmation(propertyViewingId) {
    return api.delete(
      `/property_viewings/confirmation/${propertyViewingId}/destroy`
    );
  }

  // Delete property viewing info
  deletePropertyViewingInfo(propertyViewingInfoId) {
    return api.delete(
      `/property_viewings/keep-informed/${propertyViewingInfoId}/destroy`
    );
  }

  // Keep informed about property
  keepInformed(propertyId, email) {
    return api.post(`/property_viewings/keep-informed/${propertyId}`, {
      email,
    });
  }

  // Get users for property viewings
  getUsersForPropertyViewings() {
    return api.get("/property_viewings/users");
  }

  // Search properties for typeahead (Property Viewings Create)
  searchProperties(query) {
    return api.get(`/properties/search/${encodeURIComponent(query)}`);
  }

  // Search guardians for typeahead (Property Viewings Create)
  searchGuardians(query) {
    return api.get(`/guardians/search?q=${encodeURIComponent(query)}`);
  }

  // Get user details (simple version)
  getUserSimple(userId) {
    return api.get(`/users/${userId}`);
  }

  // Get user viewing stats
  getUserViewingStats(userId) {
    return api.get(`/propertyviewings/user/${userId}/stats`);
  }

  // Get guardians for property viewings
  getGuardiansForPropertyViewings() {
    return api.get("/property_viewings/guardians");
  }

  // Get property details
  getPropertyDetails(propertyId) {
    return api.get(`/properties/${propertyId}`);
  }

  // Get property viewings calendar data
  getPropertyViewingsCalendarData(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}/calendar-data`);
  }

  // Get property viewings for DataTable
  getPropertyViewingsDataTable(propertyId, params) {
    return api.post(`/property_viewings/property/${propertyId}`, params);
  }

  // Export property viewings
  exportPropertyViewings(propertyId, format = "csv") {
    return api.get(`/property_viewings/property/${propertyId}/export`, {
      params: { format },
    });
  }

  // Get property viewings report
  getPropertyViewingsReport(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}/report`);
  }

  // Get property viewings calendar events
  getPropertyViewingsCalendarEvents(propertyId, start, end) {
    return api.get(
      `/property_viewings/property/${propertyId}/calendar-events`,
      {
        params: { start, end },
      }
    );
  }

  // Get property viewings by status
  getPropertyViewingsByStatus(propertyId, status) {
    return api.get(
      `/property_viewings/property/${propertyId}/status/${status}`
    );
  }

  // Get property viewings upcoming
  getPropertyViewingsUpcoming(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}/upcoming`);
  }

  // Get property viewings past
  getPropertyViewingsPast(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}/past`);
  }

  // Get property viewings completed
  getPropertyViewingsCompleted(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}/completed`);
  }

  // Get property viewings uncompleted
  getPropertyViewingsUncompleted(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}/uncompleted`);
  }

  // Get property viewings all
  getPropertyViewingsAll(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}/all`);
  }

  // Create multiple property viewings (storeMany)
  createViewings(data) {
    return api.post("/property_viewings/storeMany", data);
  }

  // Get users for property viewings create form (renamed to avoid duplicate)
  getUsersForCreate() {
    return api.get("/property_viewings/users");
  }

  // Get properties for typeahead
  getProperties(searchTerm) {
    return api.get("/properties/search", {
      params: { q: searchTerm },
    });
  }

  // Get guardians for typeahead
  getGuardians(searchTerm) {
    return api.get("/guardians/search", {
      params: { q: searchTerm },
    });
  }

  // API endpoints for property viewings
  // Get all property viewings (API)
  getAllPropertyViewings(params) {
    return api.post("/property_viewings/all", params);
  }

  // Get property viewing by ID (API)
  getPropertyViewingById(id) {
    return api.get("/property_viewings/get", {
      params: { id },
    });
  }

  // Get property viewings of property (API)
  getPropertyViewingsOfProperty(propertyId) {
    return api.get(`/property_viewings/property/${propertyId}`);
  }

  // Get property viewings of user (API)
  getPropertyViewingsOfUser(userId, params) {
    return api.get(`/property_viewings/user/${userId}`, { params });
  }

  // Get property viewings datatable of property (API)
  getPropertyViewingsDatatableOfProperty(propertyId, params) {
    return api.post(`/property_viewings/property/${propertyId}`, params);
  }

  // Get property viewing info of logged user (API)
  getPropertyViewingInfoOfLoggedUser(params) {
    return api.get("/property_viewings/getPropertyViewingInfoOfLoggedUser", {
      params,
    });
  }

  // Get my confirmations (API)
  getMyConfirmations(params) {
    return api.get("/property_viewings/myConfirmations", { params });
  }

  // Get property viewings report (API)
  getPropertyViewingsReportApi(params) {
    return api.post("/property_viewings/report", params);
  }

  // Update property viewing (API)
  updatePropertyViewingApi(id, data) {
    return api.put(`/property_viewings/update/${id}`, data);
  }

  // Get users for dropdown in create form (renamed to avoid duplicate)
  async getUsersForDropdown() {
    try {
      console.log("🔍 Calling users API: /propertyviewings/report");
      const response = await api.get("/propertyviewings/report");
      console.log("✅ Users API full response:", response);
      console.log("📊 Users API response data:", response.data);

      if (response.data?.success && response.data?.data?.users) {
        // Convert users object to array format
        const usersArray = Object.entries(response.data.data.users).map(
          ([id, name]) => ({
            id: parseInt(id),
            full_name: name,
            name: name,
          })
        );
        console.log("👥 Users converted to array:", usersArray);
        return usersArray;
      }
      return [];
    } catch (error) {
      console.warn("❌ Users API failed, using mock data:", error.message);
      // Fallback to mock users
      return [
        { id: 1, full_name: "John Manager", name: "John Manager" },
        { id: 2, full_name: "Jane Supervisor", name: "Jane Supervisor" },
        { id: 3, full_name: "Mike Coordinator", name: "Mike Coordinator" },
        { id: 4, full_name: "Sarah Assistant", name: "Sarah Assistant" },
        { id: 5, full_name: "Tom Organizer", name: "Tom Organizer" },
      ];
    }
  }

  // Get properties for typeahead search
  async getPropertiesForSearch(searchTerm) {
    try {
      // Try to fetch from backend API first
      try {
        const response = await api.get(
          `/properties/search?q=${encodeURIComponent(searchTerm)}`
        );
        if (response.data?.success && response.data?.properties) {
          console.log("✅ Properties API response:", response.data.properties);
          return response.data.properties;
        }
      } catch (apiError) {
        console.warn(
          "⚠️ Properties API failed, using mock data:",
          apiError.message
        );
      }

      // Fallback to mock properties
      const mockProperties = [
        {
          id: 1,
          name: "12 Savage Road",
          property_id: "PROP001",
          postcode: "PL5 1BP",
        },
        {
          id: 2,
          name: "35 University Road",
          property_id: "PROP002",
          postcode: "PO1 2DZ",
        },
        {
          id: 3,
          name: "22 High Street",
          property_id: "PROP003",
          postcode: "SW1A 1AA",
        },
        {
          id: 4,
          name: "45 Queen Street",
          property_id: "PROP004",
          postcode: "M1 1AA",
        },
        {
          id: 5,
          name: "78 King Street",
          property_id: "PROP005",
          postcode: "B1 1BB",
        },
      ];

      return mockProperties.filter(
        (property) =>
          property.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          property.property_id
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          property.postcode.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } catch (error) {
      console.error("Error fetching properties:", error);
      return [];
    }
  }

  // Get guardians for typeahead search
  async getGuardiansForSearch(searchTerm) {
    console.log("🔍 Searching guardians for term:", searchTerm);

    try {
      // Force try backend API first
      console.log(
        "🔍 Making API call to:",
        `/guardians/search?q=${encodeURIComponent(searchTerm)}`
      );

      const response = await api.get(
        `/guardians/search?q=${encodeURIComponent(searchTerm)}`
      );

      console.log("✅ Full API response:", response);
      console.log("✅ Response data:", response.data);
      console.log("✅ Response data type:", typeof response.data);
      console.log("✅ Is array?", Array.isArray(response.data));

      // Backend returns direct array: res.json(guardians)
      // Axios wraps it: response.data = [guardians array]
      let guardiansData = [];
      
      if (Array.isArray(response.data)) {
        // Direct array response (expected format)
        guardiansData = response.data;
        console.log("✅ Guardians from live database (direct array):", guardiansData);
        console.log("✅ Guardian count from database:", guardiansData.length);
      } else if (response.data?.success && Array.isArray(response.data.data)) {
        // Wrapped response format (fallback)
        guardiansData = response.data.data;
        console.log("✅ Guardians from live database (wrapped):", guardiansData);
        console.log("✅ Guardian count from database:", guardiansData.length);
      } else {
        console.log("⚠️ API response format unexpected:", response.data);
        console.log("⚠️ Response structure:", {
          type: typeof response.data,
          isArray: Array.isArray(response.data),
          hasSuccess: !!response.data?.success,
          hasData: !!response.data?.data
        });
        return [];
      }

      // Map guardians to include name and email for frontend consumption
      // Backend structure: { id, unique_guardian_number, status_id, user: { first_name, last_name, email, mobile_number } }
      const mappedGuardians = guardiansData.map((guardian) => {
        const user = guardian.user || {};
        const firstName = user.first_name || guardian.first_name || "";
        const lastName = user.last_name || guardian.last_name || "";
        const email = user.email || guardian.email || "";
        const fullName = `${firstName} ${lastName}`.trim() || "Unknown Guardian";

        return {
          id: guardian.id,
          name: fullName,
          email: email,
          unique_guardian_number: guardian.unique_guardian_number || "",
          status_id: guardian.status_id || null,
          // Keep original structure for reference
          original: guardian,
        };
      });

      console.log("✅ Mapped guardians count:", mappedGuardians.length);
      if (mappedGuardians.length > 0) {
        console.log("✅ First mapped guardian:", mappedGuardians[0]);
      }

      return mappedGuardians;
    } catch (error) {
      console.error("❌ Guardian search API error:", error);
      console.log("🔍 Error details:", error.response?.data || error.message);
      return [];
    }
  }

  // Create multiple property viewings (Laravel storeMany endpoint)
  async createMultipleViewings(data) {
    try {
      console.log("📤 Creating multiple viewings:", data);
      const response = await api.post("/propertyviewings/storeMany", data);
      console.log("✅ Multiple viewings created:", response);
      return response;
    } catch (error) {
      console.error("❌ Error creating multiple viewings:", error);
      throw error;
    }
  }

  // Get user data by ID
  async getUser(userId) {
    try {
      console.log("🔍 Calling user API for ID:", userId);
      // Try the propertyviewings user endpoint first (as seen in network tab)
      const response = await api.get(`/propertyviewings/users/${userId}`);
      console.log("✅ User API response:", response.data);

      // Handle direct user data response (not wrapped in success/data structure)
      if (response.data && response.data.id) {
        const userData = response.data;
        // Ensure fullName is available for display
        if (!userData.fullName && !userData.full_name) {
          userData.fullName = `${userData.first_name || ""} ${
            userData.last_name || ""
          }`.trim();
        }
        console.log("✅ [SERVICE] Processed user data:", userData);
        return userData;
      }

      // Fallback to wrapped response structure
      if (response.data?.success && response.data?.data) {
        const userData = response.data.data;
        if (!userData.fullName && !userData.full_name) {
          userData.fullName = `${userData.first_name || ""} ${
            userData.last_name || ""
          }`.trim();
        }
        console.log("✅ [SERVICE] Processed user data (wrapped):", userData);
        return userData;
      }

      return null;
    } catch (error) {
      console.warn(
        "❌ User API failed, trying fallback endpoint:",
        error.message
      );

      // Try fallback endpoint
      try {
        const fallbackResponse = await api.get(`/users/${userId}`);
        console.log("✅ Fallback user API response:", fallbackResponse.data);

        if (fallbackResponse.data?.success && fallbackResponse.data?.data) {
          const userData = fallbackResponse.data.data;
          if (!userData.fullName && !userData.full_name) {
            userData.fullName = `${userData.first_name || ""} ${
              userData.last_name || ""
            }`.trim();
          }
          return userData;
        }
      } catch (fallbackError) {
        console.warn("❌ Fallback API also failed:", fallbackError.message);
      }

      // Final fallback to mock user
      return {
        id: userId,
        fullName: `User ${userId}`,
        first_name: `User`,
        last_name: `${userId}`,
        email: `user${userId}@example.com`,
      };
    }
  }

  // Get user viewing statistics
  async getUserViewingStatsForCalendar(userId) {
    try {
      console.log("🔍 Calling user viewing stats API for ID:", userId);
      const response = await api.get(`/propertyviewings/user/${userId}/stats`);
      console.log("✅ User viewing stats API response:", response.data);

      if (response.data?.success && response.data?.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.warn(
        "❌ User viewing stats API failed, using mock data:",
        error.message
      );
      // Fallback to mock stats
      return {
        all: 0,
        upcoming: 0,
        past: 0,
        completed: 0,
        uncompleted: 0,
      };
    }
  }

  // Get user viewings filtered by status with pagination
  async getUserViewingsForCalendar(
    userId,
    statusFilter = null,
    timestamp = null,
    page = 1,
    pageSize = 30
  ) {
    try {
      console.log(
        "🔍 Calling user viewings API for ID:",
        userId,
        "status:",
        statusFilter,
        "page:",
        page,
        "pageSize:",
        pageSize,
        "timestamp:",
        timestamp
      );

      // Add cache-busting parameter to ensure fresh data
      const params = {};
      if (statusFilter && statusFilter !== "all") {
        params.status = statusFilter;
      }
      if (timestamp) {
        params._t = timestamp;
      }
      if (page) {
        params.page = page;
      }
      if (pageSize) {
        params.limit = pageSize;
      }

      const response = await api.get(
        `/propertyviewings/user/${userId}/viewings`,
        { params }
      );
      console.log(
        "✅ User viewings API response with fresh data:",
        response.data
      );

      if (response.data?.success) {
        // Return paginated response structure
        return {
          data: response.data.data || [],
          total: response.data.total || response.data.data?.length || 0,
          page: response.data.page || page,
          pageSize: response.data.pageSize || pageSize,
          totalPages: response.data.totalPages || Math.ceil((response.data.total || response.data.data?.length || 0) / pageSize)
        };
      }
      return { data: [], total: 0, page: 1, pageSize: pageSize, totalPages: 0 };
    } catch (error) {
      console.warn(
        "❌ User viewings API failed, using mock data:",
        error.message
      );
      // Fallback to mock viewings
      const mockData = [
        {
          id: 1,
          property_title: "12 Savage Road",
          property_id: 1,
          postcode: "PL5 1BP",
          day: "15/01/2025",
          time_from: "14:00",
          time_to: "16:00",
          confirmed: true,
          attendees: 3,
          rooms_taken: 2,
          notes: "Mock viewing data",
        },
        {
          id: 2,
          property_title: "35 University Road",
          property_id: 2,
          postcode: "PO1 2DZ",
          day: "20/01/2025",
          time_from: "10:00",
          time_to: "12:00",
          confirmed: false,
          attendees: 1,
          rooms_taken: 1,
          notes: "Another mock viewing",
        },
      ];
      return { data: mockData, total: mockData.length, page: 1, pageSize: pageSize, totalPages: 1 };
    }
  }

  // Get user calendar data
  async getUserCalendar(userId) {
    try {
      console.log("🔍 Calling user calendar API for ID:", userId);
      const response = await api.get(
        `/propertyviewings/user/${userId}/calendar`
      );
      console.log("✅ User calendar API response:", response.data);

      if (response.data?.success && response.data?.data) {
        return response.data.data;
      }
      return { events: [] };
    } catch (error) {
      console.warn(
        "❌ User calendar API failed, using mock data:",
        error.message
      );
      // Fallback to mock calendar data
      return { events: [] };
    }
  }

  // Create viewing
  async createViewing(data) {
    try {
      console.log("📤 Creating viewing:", data);
      const response = await api.post("/propertyviewings", data);
      console.log("✅ Viewing created:", response);
      return response;
    } catch (error) {
      console.error("❌ Error creating viewing:", error);
      throw error;
    }
  }

  // Update viewing
  async updateViewing(id, data) {
    try {
      console.log("📤 Updating viewing:", id, data);
      const response = await api.put(`/propertyviewings/${id}`, data);
      console.log("✅ Viewing updated:", response);
      return response;
    } catch (error) {
      console.error("❌ Error updating viewing:", error);
      throw error;
    }
  }

  // Delete viewing
  async deleteViewing(id) {
    try {
      console.log("📤 Deleting viewing:", id);
      const response = await api.delete(`/propertyviewings/${id}`);
      console.log("✅ Viewing deleted:", response);
      return response;
    } catch (error) {
      console.error("❌ Error deleting viewing:", error);
      throw error;
    }
  }

  // Copy viewing
  async copyViewingToNextWeek(id, period) {
    try {
      console.log("📤 Copying viewing:", id, period);
      const response = await api.post(`/propertyviewings/${id}/copy`, {
        period,
      });
      console.log("✅ Viewing copied:", response);
      return response;
    } catch (error) {
      console.error("❌ Error copying viewing:", error);
      throw error;
    }
  }

  // Add lunch event
  async addLunch(data) {
    try {
      console.log("📤 Adding lunch event:", data);
      const response = await api.post("/propertyviewings/lunch", data);
      console.log("✅ Lunch event added:", response);
      return response;
    } catch (error) {
      console.error("❌ Error adding lunch event:", error);
      throw error;
    }
  }

  // Update lunch event
  async updateLunch(id, data) {
    try {
      console.log("📤 Updating lunch event:", id, data);
      const response = await api.put(`/propertyviewings/lunch/${id}`, data);
      console.log("✅ Lunch event updated:", response);
      return response;
    } catch (error) {
      console.error("❌ Error updating lunch event:", error);
      throw error;
    }
  }

  // Get viewing by ID - FETCH FRESH DATA FROM BACKEND
  async getViewingById(id) {
    try {
      console.log("📤 Fetching viewing by ID:", id);
      const response = await api.get(`/propertyviewings/viewing/${id}`);
      console.log("✅ Viewing data received:", response);
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching viewing by ID:", error);
      throw error;
    }
  }
}

// Export service instance with all methods including getUsers, getProperties, getGuardians, createMultipleViewings
const propertyViewingsService = new PropertyViewingsService();
export default propertyViewingsService;
